import React, { memo } from "react";
import stylesPc from "./VideoInfoPanel.module.css";
import stylesSp from "./VideoInfoPanel_SP.module.css";
import { IsDevice } from "../../../../components/function/useDeviceFlag";
//import { Video } from "../../../../common/video/models/Video";
import { VideoTag } from "../../../../common/video/models/VideoTag";
import Tag from "../../../../common/components/tag/Tag";
import PuiTypography from "../../../../components/elements/PuiTypography";
import PuiTooltip from "../../../../components/elements/PuiTooltip ";
import { useLocation } from "react-router-dom";
import { t } from "i18next";

interface VideoInfoPanelProps {
    video: any;
}

function VideoInfoPanel({ video }: VideoInfoPanelProps) {
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : stylesSp;

    const { pathname } = useLocation();

    return (
        <div className={styles.root}>
            {video.tags.length > 0 && (
                <div className={styles.tagList}>
                    {video.tags.map((tag: VideoTag) => (
                        <Tag key={tag} tag={tag} />
                    ))}
                </div>
            )}
            <div className={styles.title} data-tip={video.title} data-for="title">
                {video.title}
            </div>
            <PuiTooltip id={"title"} />

            <div className={styles.createViewerPannel}>
                <div className={styles.presenterArea}>
                    <img
                        className={styles.presenterImg}
                        src={video.professionalImageUrl}
                        onError={(e) =>
                            (e.currentTarget.src =
                                require("../../../../assets/image/noPresenterImage.svg").default)
                        }
                        alt=""
                    />
                    <PuiTypography color={"secondary-font"} size={17}>
                        {video.presenter}
                    </PuiTypography>
                </div>
                {!pathname.startsWith("/slidestock") && (
                    <>
                        <div className={styles.viewerCountArea}>
                            <PuiTypography color={"gray-80"} size={17}>
                                {video.viewCount}
                            </PuiTypography>
                        </div>
                        <div className={styles.viewerLableArea}>
                            <PuiTypography color={"gray-80"} size={17}>
                                {t("回視聴　|　")}
                            </PuiTypography>
                        </div>
                    </>
                )}

                <PuiTypography color={"gray-80"} size={17}>
                    {window.navigator.language.substring(0, 2) === "ja"
                        ? video.created.toLocaleDateString("Ja-JP", {
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                          })
                        : video.created.toLocaleDateString("en-US")}
                </PuiTypography>
            </div>
            <div className={styles.description}>
                <PuiTypography color={"gray-80"}>{video.description}</PuiTypography>
            </div>
        </div>
    );
}

export default memo(VideoInfoPanel);
